module.exports = __webpack_public_path__ + "img/mkt_failed.c3ea0684.svg";